import { render } from "./SingleAlert.vue?vue&type=template&id=1ccf8eb0"
import script from "./SingleAlert.vue?vue&type=script&lang=js"
export * from "./SingleAlert.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__